import { PublishJobType } from '../enums/publish-job-type';
import { PublishTaskType } from '../enums/publish-task-type';

export class PublishStepper {
    taskType: PublishTaskType = undefined;
    jobType: PublishJobType = undefined;
    label: string = undefined;
    status: string = undefined;

    public constructor(init?: Partial<PublishStepper>) {
        Object.assign(this, init);
    }
}
